import React, { Component } from 'react';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import { Button } from 'antd';
import { countDown, subTime, onResize } from '@/shared/functions';
import { Root, Top, Time, Content } from '../_style/BeforeAuction';
const mapStateToProps = (rootState) => ({
    _auctioneer: rootState.auctionOperate,
});
class BeforeAuction extends Component {
    constructor(props) {
        super(props);
        /**
         * @desc 窗口变更调用的函数
         */
        this.onResize = () => {
            // 实际区域宽高
            const designSizeH = 606;
            onResize('_auctioneerNobegin', designSizeH);
        };
        this.simulate = () => {
            // 告诉后端我点击了模拟拍卖
            dispatch.auctionOperate.clickedSimulate({});
        };
        this.formal = () => {
            // 告诉后端我点击了正式拍卖
            dispatch.auctionOperate.clickedFormal({});
        };
        this.state = {
            _count: 0,
            counts: '00:00:00',
        };
    }
    componentWillMount() {
        // 设置html rem值
        window.addEventListener('resize', this.onResize, false);
    }
    componentDidMount() {
        this.onResize();
        const _count = setInterval(() => {
            const { sessionBeginTime } = this.props._auctioneer;
            const counts = countDown(sessionBeginTime);
            if (counts === '00:00:00') {
                const { _count } = this.state;
                clearInterval(_count);
            }
            this.setState({
                counts,
            });
        }, 1000);
        this.setState({
            _count,
        });
        // 处理计算不准确的问题
        setTimeout(() => {
            this.onResize();
        }, 0);
    }
    componentWillUnmount() {
        const { _count } = this.state;
        clearInterval(_count);
        window.removeEventListener('resize', this.onResize, false);
    }
    render() {
        const { counts } = this.state;
        const { style, className } = this.props;
        const { sessionName, sessionBeginTime, totalCarNum } = this.props._auctioneer;
        const beginTimePart = subTime(sessionBeginTime);
        return (<Root style={style} className={className} id="_auctioneerNobegin">
        <Top>距离计划开拍时间</Top>
        <Time>{counts}</Time>
        <Content>
          <span>{sessionName}</span>
          <span style={{ marginLeft: 10 }}>{beginTimePart}场</span>
          <span style={{ marginLeft: 30 }}>共{totalCarNum}辆车</span>
        </Content>
        <Button className="btn_simulate" onClick={this.simulate}>模拟拍卖</Button>
        <Button className="btn_formal" onClick={this.formal}>正式拍卖</Button>
      </Root>);
    }
}
export default connect(mapStateToProps)(BeforeAuction);
